export const SET_UTM_ORIGIN = 'SET_UTM_ORIGIN';
export const SET_AT_UNIT = 'SET_AT_UNIT';
export const SET_TEAM_NAME = 'SET_TEAM_NAME';
export const SET_FLOW_STEPS = 'SET_FLOW_STEPS';
export const SET_T2_FLOW = 'SET_T2_FLOW';
export const SET_PAYMENT_BYPASS = 'SET_PAYMENT_BYPASS';
export const SET_VACCINE_FLOW = 'SET_VACCINE_FLOW';
export const SET_COLLABORATOR_FLOW = 'SET_COLLABORATOR_FLOW';
export const SET_IS_NAV = 'SET_IS_NAV';
export const SET_ALTERNATIVE_MESSAGE_DATA = 'SET_ALTERNATIVE_MESSAGE_DATA';
export const SET_IS_SCHEDULED_ADMISSION = 'SET_IS_SCHEDULED_ADMISSION';
export const SET_HAS_SURVEY = 'SET_HAS_SURVEY';
export const SET_ONLINE_PAYMENT_ENABLED = 'SET_ONLINE_PAYMENT_ENABLED';
export const SET_HOUR_ADMISSION_WITHOUT_SCHEDULING = 'SET_HOUR_ADMISSION_WITHOUT_SCHEDULING';
export const SET_ADMISSION_FLOWS = 'SET_ADMISSION_FLOWS';
export const SET_AMIL_TOKENS_TO_VALIDATE = 'SET_AMIL_TOKENS_TO_VALIDATE';
export const SET_IS_INCOMPANY_FLOW = 'SET_IS_INCOMPANY_FLOW';
export const SET_SERVICES_CHANGE = 'SET_SERVICES_CHANGE';
export const SET_BUTTON_CONFIRM_ARRIVAL = 'SET_BUTTON_CONFIRM_ARRIVAL';
export const SET_LIST_CATEGORY_EXAMS = 'SET_LIST_CATEGORY_EXAMS';
export const SET_USER_CHECKIN_ORIGIN = 'SET_USER_CHECKIN_ORIGIN';
export const SET_BRADESCO_FLOW = 'SET_BRADESCO_FLOW';
